export default class newsletterSection{

    constructor() {
        this.container = document.querySelector('.newsletter_section');

        // Is the element present on the current page
        if (!this.container) {
            return;
        }
        this.subsPanelInitial = document.querySelector('.newsletter__initial');
        this.subButton = document.querySelector('.newsletter__button');
        this.emailRegex = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?");
        this.formCont = document.querySelector('.fl-form');
        this.formThankyou = document.querySelector('.form__thankyou');

        //this.body = document.querySelector('body');

        //Checkboxes product lines
        //this.argetaProdCheck = document.getElementById('Argeta');
        //this.argetaJuniorProdCheck = document.getElementById('ArgetaJunior');
        //this.argetaExclusiveProdCheck = document.getElementById('ArgetaExclusive');
         //Checkboxes checked depend of product line
        //this.activeCheckboxes();

        this.subButton.addEventListener("click", (e) => {
            e.preventDefault();
            this.newsletterValidate();
        });

    }

    newsletterValidate() {
        if (validate_initial('.subscription__initial--desktop')) {
            $('.form__invalid').hide();
        } else {
            return;
        }
        if (!validate_categories('.form__check-desktop')) {
            return;
        }
        this.container.scrollIntoView();
        this.formCont.style.display = 'none';
        this.formThankyou.style.display = 'block';

        ga('send', 'event', 'subscription-desktop-open', 'click', 'webpage');

        // Email + terms
        function validate_initial(selector) {
            let emailRegex = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?");
            let valid = true;

            if (!emailRegex.test($(selector + ' .form__email').val())) {
                $(selector + ' #error-email').slideDown();
                valid = false;
            } else {
                $(selector + ' #error-email').slideUp();
            }

            if (!$(selector + ' .form__check').is(':checked')) {
                $(selector + ' #error-terms').slideDown();
                valid = false;
            } else {
                $(selector + ' #error-terms').slideUp();
            }

            return valid;
        }

        // we need at least 1 element selected
        function validate_categories(selector) {
            let valid = false;

            // jQuery .each breaks after false is returned.
            // If a checkbox is checked we return false
            $(selector).each(function () {
                if ($(this).is(':checked')) {
                    valid = true;
                    return false;
                }
            });

            if (!valid) {
                //$(selector + ' .form__invalid').slideDown();
                $('#error-checkbox').slideDown();
            } else {
                //$(selector + ' .form__invalid').slideUp();
                $('#error-checkbox').slideUp();
            }

            return valid;
        }

    }

   /* activeCheckboxes () {
        if(this.body.classList.contains('junior')) {
            this.argetaJuniorProdCheck.checked = 'checked';
        } else if(this.body.classList.contains('exclusive')) {
            this.argetaExclusiveProdCheck.checked = 'checked';
        } else {
            this.argetaProdCheck.checked = 'checked';
        }
    }*/
}
